export const standardSizes = ["P", "M", "G", "XL", "XXL", "XXXL", "XXXXL"];
